import { render, staticRenderFns } from "./QuiltyInsightsGeneralView.vue?vue&type=template&id=73c5b2d6&"
import script from "./QuiltyInsightsGeneralView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyInsightsGeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports